import { TableContainer, Paper, TableHead, TableRow, TableCell, TableBody, styled, Button, useMediaQuery, Theme, Skeleton } from "@mui/material";
import { SettingTable, settingUseStyles } from "../Settings";
import TextCell from "./TextCell";
import { THEME } from "../../../config";

const ClearButton = styled(Button)(() => ({
    fontWeight: 500,
    fontSize: "1rem",
    textTransform: "none",
    color: THEME.palette.text.secondary
}))

interface IManagementSettingTableProps {
    hasClear?: boolean,
    isMobile: boolean,
    activeClearButton: boolean,
    setDialogOpen: (boolean: boolean) => void
    managementState: {
        [key: string]: object;
    } | undefined
}

const ManagementSettingTable: React.FC<IManagementSettingTableProps> = (props) => {

    const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));
    const classes = settingUseStyles()

    const handleButtonClick = () => {
        props.setDialogOpen(true)
    }

    const getColSpan = (): number => {
        if (props.isMobile)
            return 3;
        if (isSmall)
            return 2;
        return 1
    }

    const showButton = () => {
        return (
            (props.managementState?.allowClearDb)?
                <ClearButton
                    onClick={handleButtonClick}
                    disabled={!props.managementState?.allowClearDb || !props.activeClearButton}
                    variant="contained"
                    color="error"
                >
                    Clear database
                </ClearButton>
                : null
        )
    }
    const showTableRow = (name: string, value: object | undefined) => {
        if (props.isMobile) {
            return (
                <TableRow>
                    <TableCell width={"50%"} colSpan={getColSpan()}>
                        {name}
                    </TableCell>
                    <TableCell colSpan={3}>
                        {value === undefined ? <Skeleton/> : value.toString()}
                    </TableCell>
                </TableRow>
            );
        } if (isSmall) {
            return (
                <TableRow>
                    <TableCell width={"50%"} colSpan={getColSpan()}>
                        {name}
                    </TableCell>
                    <TableCell colSpan={3}>
                        {value === undefined ? <Skeleton/> : value.toString()}
                    </TableCell>
                </TableRow>
            );
        } else {
            return (
                <TableRow>
                    <TableCell width={"25%"} colSpan={getColSpan()}>
                        {name}
                    </TableCell>
                    <TableCell colSpan={3}>
                        {value === undefined ? <Skeleton/> : value.toString()}
                    </TableCell>
                </TableRow>
            );
        }
    }

    return (
        <TableContainer component={Paper} className={classes.container}>
            <SettingTable>
                <TableHead>
                    <TableRow>
                        <TextCell head colspan={props.hasClear? 3 : 6} title="Management settings" subtitle="You may find the necessary management information here. Please get in touch with us if you can't find what you're looking for."/>
                        {props.hasClear?  
                            <TableCell align="right" colSpan={3} width={"20%"}>
                                {showButton()}
                            </TableCell>
                            : null
                        }
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan={getColSpan()}>
                            Name
                        </TableCell>
                        <TableCell colSpan={3}>
                            Value
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {showTableRow("Allow setting override", props.managementState?.allowSettingsOverride)}
                    {showTableRow("Allow clear db", props.managementState?.allowClearDb)}
                    {showTableRow("Prefix mode enabled", props.managementState?.prefixMode)}
                </TableBody>
            </SettingTable>
        </TableContainer>
    );
}

export default ManagementSettingTable;